import {
  Pagination,
  Dialog,
  Autocomplete,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Scrollbar,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  TimePicker,
  Popover,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Alert,
  Slider,
  Icon,
  Row,
  Col,
  Upload,
  Progress,
  Badge,
  Card,
  Rate,
  Steps,
  Step,
  Carousel,
  CarouselItem,
  Collapse,
  CollapseItem,
  Cascader,
  ColorPicker,
  Transfer,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Loading,
  MessageBox,
  Message,
  Notification
} from "element-ui";
const luScrollbar = Scrollbar;
const luPagination = Pagination;
const luDialog = Dialog;
const luAutocomplete = Autocomplete;
const luDropdown = Dropdown;
const luDropdownMenu = DropdownMenu;
const luDropdownItem = DropdownItem;
const luMenu = Menu;
const luSubmenu = Submenu;
const luMenuItem = MenuItem;
const luMenuItemGroup = MenuItemGroup;
const luInput = Input;
const luInputNumber = InputNumber;
const luRadio = Radio;
const luRadioGroup = RadioGroup;
const luRadioButton = RadioButton;
const luCheckbox = Checkbox;
const luCheckboxButton = CheckboxButton;
const luCheckboxGroup = CheckboxGroup;
const luSwitch = Switch;
const luSelect = Select;
const luOption = Option;
const luOptionGroup = OptionGroup;
const luButton = Button;
const luButtonGroup = ButtonGroup;
const luTable = Table;
const luTableColumn = TableColumn;
const luDatePicker = DatePicker;
const luTimeSelect = TimeSelect;
const luTimePicker = TimePicker;
const luPopover = Popover;
const luTooltip = Tooltip;
const luBreadcrumb = Breadcrumb;
const luBreadcrumbItem = BreadcrumbItem;
const luForm = Form;
const luFormItem = FormItem;
const luTabs = Tabs;
const luTabPane = TabPane;
const luTag = Tag;
const luTree = Tree;
const luAlert = Alert;
const luSlider = Slider;
const luIcon = Icon;
const luRow = Row;
const luCol = Col;
const luUpload = Upload;
const luProgress = Progress;
const luBadge = Badge;
const luCard = Card;
const luRate = Rate;
const luSteps = Steps;
const luStep = Step;
const luCarousel = Carousel;
const luCarouselItem = CarouselItem;
const luCollapse = Collapse;
const luCollapseItem = CollapseItem;
const luCascader = Cascader;
const luColorPicker = ColorPicker;
const luTransfer = Transfer;
const luContainer = Container;
const luHeader = Header;
const luAside = Aside;
const luMain = Main;
const luFooter = Footer;
const luLoading = Loading;
const luMessageBox = MessageBox;
const luMessage = Message;
const luNotification = Notification;

export {
  luScrollbar,
  luDialog,
  luPagination,
  luNotification,
  luMessage,
  luMessageBox,
  luLoading,
  luFooter,
  luMain,
  luAside,
  luHeader,
  luContainer,
  luTransfer,
  luColorPicker,
  luCollapseItem,
  luCollapse,
  luCarousel,
  luCarouselItem,
  luCascader,
  luStep,
  luSteps,
  luRate,
  luCard,
  luBadge,
  luProgress,
  luUpload,
  luCol,
  luRow,
  luIcon,
  luSlider,
  luAlert,
  luTree,
  luPopover,
  luTimePicker,
  luTimeSelect,
  luDatePicker,
  luTableColumn,
  luTable,
  luButtonGroup,
  luButton,
  luTag,
  luTabPane,
  luTabs,
  luFormItem,
  luForm,
  luBreadcrumbItem,
  luBreadcrumb,
  luAutocomplete,
  luDropdown,
  luDropdownMenu,
  luDropdownItem,
  luMenu,
  luSubmenu,
  luMenuItem,
  luMenuItemGroup,
  luInput,
  luInputNumber,
  luRadio,
  luRadioGroup,
  luRadioButton,
  luCheckbox,
  luCheckboxButton,
  luCheckboxGroup,
  luSwitch,
  luSelect,
  luOption,
  luOptionGroup,
  luTooltip
};
